"use strict";

import "../../scss/pages/publications-list.scss";
import TomSelect from "tom-select/dist/js/tom-select.complete.min";
import PublicationsTable from "../components/publicationTable";
import { translationCountryNames } from '../helpers/TranslationCountries';

document.addEventListener("DOMContentLoaded", function () {
	const publicationsTableModule = new PublicationsTable();
	const table = document.querySelector('#award-filter-data-holder');
	const resetFilterText = table.dataset.resetFilter;
	const filterButtonList = document.querySelectorAll('.btn-filter-default');
	const urlParams = new URLSearchParams(window.location.search);
	const pageParamQuery = urlParams.get('page');
	const countryParamQuery = urlParams.get('country');
	const typeListParamQuery = urlParams.get('type') ? urlParams.get('type').split(',') : [];
	let isSetCountryOnInitialize = true;
	
	let regionName = translationCountryNames();
	
	new TomSelect("#selectMapCountry", {
		create: false,
		labelField: 'Iso3166',
		valueField: 'Iso3166',
		allowEmptyOption: false,
		maxOptions: null,
		plugins: ['dropdown_input'],
		maxItems: 1,
		selectOnTab: true,
		closeAfterSelect: true,
		searchField: ['IsoName', 'Iso3166'],
		options: [
			{Iso3166: "reset", IsoName: resetFilterText},
		],
		hideSelected: true,
		render: {
			item: function (item, escape) {
				let itemElement;
				if (item.Iso3166 === 'reset') {
					itemElement = '<div data-countryCode="' + escape(item.Iso3166) + '">' +
						'<span class="flag reset"><i class="npicn-browsing" /></i></span>' +
						'<span class="name">' + escape(item.IsoName) + '</span>' +
						'<span class="name-rtl">' + escape(item.IsoName) + '</span>' +
						'</div>';
				} else {
					itemElement = '<div data-countryCode="' + escape(item.Iso3166) + '">' +
						'<span class="flag"><span class="fi fi-' + escape(item.Iso3166) + ' fib"></span></span>' +
						'<span class="name">' + escape(item.Iso3166.toUpperCase()) + ' - ' + escape(regionName.of(item.Iso3166.toUpperCase())) + '</span>' +
						'<span class="name-rtl">' + ' - ' + escape(regionName.of(item.Iso3166.toUpperCase())) + '</span>' +
						'</div>';
				}
				
				return itemElement;
			},
			option: function (item, escape) {
				const countryCode = item.Iso3166 === 'reset' ? item.Iso3166.toUpperCase() : regionName.of(item.Iso3166.toUpperCase());
				let optionElement = '<div>' +
					'<span class="flag"><span class="fi fi-' + escape(item.Iso3166) + ' fib"></span></span>' +
					'<span class="name">' + escape(item.Iso3166.toUpperCase()) + ' - ' + countryCode + '</span>' +
					'<span class="name-rtl">' + escape(item.Iso3166.toUpperCase()) + ' - ' + countryCode + '</span>' +
					'</div>';
				if (item.Iso3166 === 'reset') {
					optionElement = '<div>' +
						'<span class="flag reset"><i class="npicn-browsing" /></i></span>' +
						'<span class="name">' + escape(item.IsoName) + '</span>' +
						'<span class="name-rtl">' + escape(item.IsoName) + '</span>' +
						'</div>';
				}
				return optionElement;
			}
		},
		onInitialize: function () {
			const urlParams = new URLSearchParams(window.location.search);
			const countryParamQuery = urlParams.get('country');
			publicationsTableModule.getCountryList();
			
			if (countryParamQuery) {
				this.setValue(countryParamQuery);
				isSetCountryOnInitialize = false;
			}
		},
		onChange: function (event) {
			if (isSetCountryOnInitialize) {
				publicationsTableModule.setCountryFilter(event);
				publicationsTableModule.updateUrlPublication('country', event !== 'reset' ? event : null);
				publicationsTableModule.updateUrlPublication('page', 1);
			}
			
			isSetCountryOnInitialize = true;
		}
	});
	
	if (pageParamQuery) {
		table.dataset.pageSelected = pageParamQuery;
	}
	
	if (countryParamQuery) {
		table.dataset.countrySelected = countryParamQuery;
	}
	if ([...filterButtonList].length > 0) {
		[...filterButtonList].forEach((filterButton) => {
			if (typeListParamQuery.includes(filterButton.dataset.type)) {
				publicationsTableModule.enableFilterButton(filterButton);
			}
			filterButton.addEventListener('click', () => {
				publicationsTableModule.enableFilterButton(filterButton, true);
			});
		});
	}
	
	publicationsTableModule.refreshPublicationsTable(pageParamQuery === '1');
});
